import { connect } from 'react-redux';
import { BasicInfo, IBasicInfoProps } from '../../components/BasicInfo';
import {
  getNewbuildingDisplayName,
  getSpecialStatusDisplay,
  getFullAddress,
  getUndergroundInfo,
  getRoadInfo,
  getRegionId,
  getIsSalesLeader,
  getSalesLeaderUrl,
  getSpecifications,
  getHousesByTurnDisplay,
  getHousesCount,
  getNewbuildingWebsite,
} from '../../selectors/newbuilding';
import { IApplicationState } from '../../types/redux';

export function mapStateToProps(state: IApplicationState): IBasicInfoProps {
  return {
    basic: {
      name: getNewbuildingDisplayName(state),
      specialStatusDisplay: getSpecialStatusDisplay(state),
      isSalesLeader: getIsSalesLeader(state),
      salesLeaderUrl: getSalesLeaderUrl(state),
      website: getNewbuildingWebsite(state),
    },
    address: {
      fullAddress: getFullAddress(state),
      regionId: getRegionId(state),
      undergroundInfo: getUndergroundInfo(state),
      roadInfo: getRoadInfo(state),
    },
    specifications: getSpecifications(state),
    housesByTurnDisplay: getHousesByTurnDisplay(state),
    housesCount: getHousesCount(state),
  };
}

export const BasicInfoContainer = connect(mapStateToProps)(BasicInfo);
